export const ContentCategory = Object.freeze({
  ARTICLES: 'Artigos',
});